module.exports = __webpack_public_path__ + "../../../static/img/c_im_6.a94ac044.png";